module.exports = __webpack_public_path__ + "static/media/eu.21c3b86b.svg";